export const WEGO_TEN_LIST = [
  "5CBA74C728B64856A7913115E1C25AA6",
  "CD969BCAAED649CE84E85BA591D2208C",
];

export const ROBOT_TEN_LIST = [
  "8739095DAFDC4E4494BD8D99089AB15F",
  "5CBA74C728B64856A7913115E1C25AA6",
  "967C2F6B3FCB4B58BF8727151CF94B98",
  "B049D9F896BA4760A928AB2A549FBB59",
  "41962AC5B6664D35831F1C2321FD330A",
  "3B2DD5126001464CA343C61E0829A56B",
  "C91AD304DF5D4E5A97065A7F102A982D"
];